export default {
  applyChangesButton: 'Apply changes',
  buttonJumpToStart: 'Back to start',
  buttonRewind: 'Move {0} steps ({1}) back',
  buttonPlay: 'Play',
  buttonPause: 'Pause',
  buttonFastForward: 'Move {0} steps ({1}) forward',
  buttonJumpToEnd: 'Jump to end',
  buttonNextStep: 'Next recipe step',
  buttonPrevStep: 'Previous recipe step',
};
